import WhiteButtonUi from './ui/WhiteButtonUi'

export default WhiteButtonUi

